import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useUpgradeFlow } from 'lib/hooks/use-upgrade-flow'
import UpgradeSuccessModal from 'components/upgrade-success-modal'
import {
  RecurringDatesInput,
  ScheduleTypeSelect,
  SCHEDULE_TYPE_RECURRING,
} from 'components/group-events/recurring-schedule'
import ScheduleSessions from 'pages/pga-coach/bookings/events/edit/edit-event-form/form-sections/schedule-sessions'
import { useStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

export const UPGRADE_PAGE_NAME = 'group-event-recurring'

const CreateEventSchedule = ({ timezone }) => {
  const classes = useStyles()
  const { watch, getValues, setValue } = useFormContext()
  const scheduleType = watch('scheduleType')
  const {
    hasPaidTier,
    showSuccessModal,
    upgradeLoading,
    handleUpgradeClick,
    handleDismiss,
  } = useUpgradeFlow(UPGRADE_PAGE_NAME)

  const isRecurring = scheduleType === SCHEDULE_TYPE_RECURRING && hasPaidTier

  // Keep only the first date when switching between series and recurring so
  // hidden recurring rows don't submit unseen and a series doesn't inherit
  // many generated recurring dates.
  const handleTypeChange = nextType => {
    const [firstDate] = getValues('sessions') || []
    if (!firstDate) return

    const isNextRecurring = nextType === SCHEDULE_TYPE_RECURRING
    if (isRecurring && !isNextRecurring) {
      setValue('sessions', [firstDate])
    } else if (!isRecurring && isNextRecurring) {
      setValue('sessions', [firstDate])
    }
  }

  return (
    <>
      <Box className={classes.fieldGroup}>
        <Typography className={classes.sectionHeading}>Event type</Typography>
        <ScheduleTypeSelect
          isRecurringLocked={!hasPaidTier}
          onUpgradeClick={handleUpgradeClick}
          upgradeLoading={upgradeLoading}
          onTypeChange={handleTypeChange}
        />
      </Box>
      {isRecurring ? (
        <RecurringDatesInput timezone={timezone} />
      ) : (
        <ScheduleSessions timezone={timezone} />
      )}
      <UpgradeSuccessModal isOpen={showSuccessModal} onClose={handleDismiss} />
    </>
  )
}

CreateEventSchedule.propTypes = {
  timezone: PropTypes.string,
}

export default CreateEventSchedule
